import { useQuery } from 'react-query';
import CardRelatorio from './CardRelatorio';
import Valor from './Valor';
import axios from 'axios';
import Skeleton from '../../components/layout/Skeleton';
import { dateWithoutTimezone } from '../../lib/util';
import { translateFilter } from './util';

type Props = {
  periodo: [string, string, string];
  canal_id: number[];
};

const CardRelatorioTotalMensagens = ({ periodo, canal_id }: Props) => {
  const q = useQuery(
    ['totalMensagens', periodo, canal_id],
    async () => {
      const qs = new URLSearchParams();
      qs.append('facts', 'qtd_mensagens');
      qs.append('filter', translateFilter({ periodo, canal_id }));

      const res = await axios.get(
        '/api/relatorios/chat_mensagem?' + qs.toString(),
      );
      return res.data.result[0].qtd_mensagens ?? 0;
    },
    { refetchOnWindowFocus: false },
  );

  return (
    <CardRelatorio
      titulo="Mensagens"
      mostrarVisualizador={true}
      filtroVisualizador={{ periodo, canal_id }}
      metricasVisualizador={['qtd_mensagens']}
      dimensoesVisualizador={['origem', 'conteudo']}
      hrefVisualizador="/api/relatorios/chat_mensagem"
      notaVisualizador="Para maiores detalhes veja a tela Históricos de mensagens"
      info="Quantidade de mensagens enviadas/recebidas no período."
      csv
    >
      {q.isFetching ? <Skeleton format="box" /> : <Valor valor={q.data} />}
    </CardRelatorio>
  );
};

export default CardRelatorioTotalMensagens;
